<div class="zx-max-100-vh h-100 w-100 d-flex flex-column flex-grow-1">

    <div class="position-absolute w-100 d-flex" [class.justify-content-end]="isRTL">
        <button type="button" mat-icon-button aria-label="Toggle sidenav" (click)="closeResizeDialog()"
            class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Main content -->
    <div class="d-flex flex-grow-1 flex-column align-items-center px-3 pb-lg-3 px-lg-4 pt-lg-5 w-100 c-default">
        <!-- title -->
        <h4 class="text-center fw-bold m-0 pt-0 pb-lg-3 pt-3 pt-lg-0" [class.zx-ltr]="!isRTL"
            [class.text-white]="isDarkMode">
            <span *ngIf="currentFile.images?.length === 1">
                {{ "resize-title-singlepage" | translate }}
            </span>
            <span *ngIf="currentFile.images?.length !== 1">
                <span>
                    {{ "resize-title-manypages" | translate }}
                </span>
                <span class="px-1 px-lg-2" [class.zx-text-pink]="!isDarkMode">
                    {{currentImageIndex + 1}}
                </span>
                <span>
                    {{ "apply-to-all-yes-explanation-1-manypages-2" | translate }}
                </span>
            </span>
            <span class="px-1 px-lg-2" [class.zx-ltr]="!isRTL" [class.zx-rtl]="isRTL">
                <span [class.zx-text-pink]="!isDarkMode && !isMustResize">
                    {{ getDisplayFileNameAfterSplit(currentFile) | slice:0:27 }}
                </span>
                <span [class.zx-text-pink]="!isDarkMode" *ngIf="getDisplayFileNameAfterSplit(currentFile).length > 27">
                    ...
                </span>
            </span>
        </h4>
        <b *ngIf="isMustResize" class="text-center w-100 pt-2 pt-lg-0 pb-lg-3 px-2 px-lg-4 zx-text-pink"
            [class.zx-text-white]="isDarkMode">
            {{ "printing-table.size-fit-required" | translate }}
        </b>
        <!-- explanation -->
        <div class="m-0 px-2 pt-2 pt-lg-0 d-flex flex-column gap-1 w-100 zx-max-w-lg-modal" style="line-height: 30px;"
            [class.zx-ltr]="!isRTL">
            <!-- original dpi -->
            <div class="w-100" [class.text-white]="isDarkMode" [class.zx-ltr]="!isRTL" [class.text-start]="!isRTL">
                <span class="zx-text-medium">
                    <span *ngIf="isVectoric">
                        <span>
                            {{ 'resize-explanation-original-unknown-1' | translate }}
                        </span>
                        <span>
                            {{format}}
                        </span>
                        <span>
                            {{ 'resize-explanation-original-unknown-2' | translate }}
                        </span>
                    </span>
                    <span *ngIf="!isVectoric">
                        <span *ngIf="currentFile.images?.length === 1">
                            {{ "resize-explanation-original-singlepage" | translate }}
                        </span>
                        <span *ngIf="currentFile.images?.length !== 1">
                            {{ "resize-explanation-original-manypages" | translate }}
                        </span>
                    </span>
                </span>
                <span class="zx-text-big">
                    <b>{{asumedDPI}}</b>
                    <b class="zx-text-small">
                        DPI
                    </b>
                </span>
                <!-- resized dpi -->
                <span class="zx-text-medium">
                    <span *ngIf="resizeNewFactor > 100">
                        {{ "resize-explanation-resized-will-grow" | translate }}
                    </span>
                    <span *ngIf="resizeNewFactor === 100">
                        {{ "resize-explanation-resized-will-stay" | translate }}
                    </span>
                    <span *ngIf="resizeNewFactor < 100">
                        {{ "resize-explanation-resized-will-shrink" | translate }}
                    </span>
                </span>
                <!-- presentege in pill -->
                <span class="zx-text-pink zx-text-big no-wrap">
                    <b *ngIf="isRTL" [class.zx-text-white]="isDarkMode">%</b>
                    <input type="number" min="1" [max]="maxNewFactor" step="0.1" [(ngModel)]="roundResizeNewFactor"
                        class="inline-input zx-input-underline" [class.zx-text-white]="isDarkMode">
                    <b *ngIf="!isRTL" [class.zx-text-white]="isDarkMode">%</b>
                </span>
                <!-- // presentege in pill -->
                <span>
                    <span>
                        {{ "resize-explanation-resized-will-print" | translate }}
                    </span>
                </span>
                <span class="zx-text-big">
                    <b>
                        {{roundDown(asumedDPI *
                        (100 / (resizeNewFactor < maxNewFactor ? resizeNewFactor : maxNewFactor))) }} </b>
                            <b class="zx-text-small">
                                DPI
                            </b>
                </span>
                <span>
                    {{ "resize-explanation-resized-that" | translate }}
                </span>
                <!-- quality -->
                <b>
                    <span class="text-orange" [class.zx-text-white]="isDarkMode"
                        *ngIf="asumedDPI * (100 / resizeNewFactor) === 0">
                        {{ 'printing-table.rank-undefined' | translate }}
                    </span>
                    <span class="text-green" [class.zx-text-white]="isDarkMode"
                        *ngIf="asumedDPI * (100 / resizeNewFactor) > 300">
                        {{ 'printing-table.rank-high' | translate }}
                    </span>
                    <span class="text-green" [class.zx-text-white]="isDarkMode"
                        *ngIf="asumedDPI * (100 / resizeNewFactor) === 300">
                        {{ 'printing-table.rank-exact' | translate }}
                    </span>
                    <span class="text-green" [class.zx-text-white]="isDarkMode" *ngIf="asumedDPI * (100 / resizeNewFactor) >= 200 &&
                        asumedDPI * (100 / resizeNewFactor) < 300">
                        {{ 'printing-table.rank-high' | translate }}
                    </span>
                    <span class="text-orange" [class.zx-text-white]="isDarkMode" *ngIf="asumedDPI * (100 / resizeNewFactor) >= 120 &&
                        asumedDPI * (100 / resizeNewFactor) < 200">
                        {{ 'printing-table.rank-medium' | translate }}
                    </span>
                    <span class="text-red" [class.zx-text-white]="isDarkMode" *ngIf="asumedDPI * (100 / resizeNewFactor) >= 72 &&
                        asumedDPI * (100 / resizeNewFactor) < 120">
                        {{ 'printing-table.rank-low' | translate }}
                    </span>
                    <span class="text-red" [class.zx-text-white]="isDarkMode" *ngIf="asumedDPI * (100 / resizeNewFactor) < 72 &&
                    asumedDPI * (100 / resizeNewFactor) !== 0">
                        {{ 'printing-table.rank-v-low' | translate }}
                    </span>
                </b>
                <!-- // quality -->
            </div>
        </div>

        <!-- image preview -->
        <article class="w-100 flex-grow-1 d-flex flex-column align-items-center h-100 zx-max-h-resize-image">
            <div class="d-flex zx-w-resize-preview zx-h-resize-preview-dim">
                <div class="d-flex zx-w-resize-preview-dim h-100"></div>
                <div id="zx-resize-input-con-top" class="d-flex h-100 justify-content-center align-items-center">

                    <span class="zx-text-pink zx-text-big no-wrap zx-z-index-1">
                        <span *ngIf="!isRTL" class="px-1 zx-text-small" [class.zx-text-white]="isDarkMode">
                            {{ 'printing-table.dimensions-cm' | translate }}
                        </span>
                        <span class="zx-input-resize-cm zx-input-underline">
                            <input type="number" step="0.1" [ngModel]="calculatedWidthValue"
                                (blur)="onWidthBlur($event)" (focusout)="onWidthBlur($event)" [max]="maxWidthLength"
                                class="inline-input zx-input-resize-cm" [class.zx-ltr]="!isRTL"
                                [class.zx-text-white]="isDarkMode">
                        </span>
                        <span *ngIf="isRTL" class="px-1 zx-text-small" [class.zx-text-white]="isDarkMode">
                            {{ 'printing-table.dimensions-cm' | translate }}
                        </span>
                    </span>

                </div>
            </div>
            <div class="d-flex zx-w-resize-preview flex-grow-1" style="min-height: 0;">
                <div id="zx-resize-input-con-side"
                    class="d-flex zx-w-resize-preview-dim flex-grow-1 justify-content-center align-items-center">

                    <span class="zx-text-pink zx-text-big no-wrap zx-z-index-1">
                        <span *ngIf="!isRTL" class="px-1 zx-text-small" [class.zx-text-white]="isDarkMode">
                            {{ 'printing-table.dimensions-cm' | translate }}
                        </span>
                        <span class="zx-input-resize-cm zx-input-underline">
                            <input type="number" step="0.1" [ngModel]="calculatedHeightValue"
                                (blur)="onHeightBlur($event)" (focusout)="onHeightBlur($event)" [max]="maxHeightLength"
                                class="inline-input zx-input-resize-cm" [class.zx-ltr]="!isRTL"
                                [class.zx-text-white]="isDarkMode">
                        </span>
                        <span *ngIf="isRTL" class="px-1 zx-text-small" [class.zx-text-white]="isDarkMode">
                            {{ 'printing-table.dimensions-cm' | translate }}
                        </span>
                    </span>

                </div>
                <div id="zx-resize-image-com" class="d-flex flex-grow-1">
                    <img id="zx-resize-image" [src]="imagePath"
                        [src]="serverAddress+'/uploads/' + getUserName() + '/' + currentImage.thumbnailPath.split('/').pop()"
                        alt="Image Preview" class="object-fit-contain rounded-1">
                </div>
            </div>
        </article>
        <!-- // image preview -->

        <!-- slider area -->
        <div id="zx-numbers-con"
            class="w-100 d-flex flex-column align-items-center px-2 px-lg-3 position-relative zx-pt-input">
            <!-- numbers -->
            <div class="w-100 d-flex">
                <div id="zx-numbers-con" class="w-100 d-flex justify-content-between zx-z-index-2"
                    [class.text-gray]="isDarkMode">
                    <span class="position-relative">
                        <span id="num-1" (click)="jumpPercent(1)"
                            [class.zx-choosen-size]="resizeNewFactor !== 0 && resizeNewFactor < 25 / 10"
                            class="position-absolute bottom-0 zx-centered zx-size c-pointer zx-text-small">
                            <span *ngIf="maxNewFactor >= 1">1%</span>
                            <span
                                *ngIf="resizeNewFactor !== 1 && resizeNewFactor !== 0 && resizeNewFactor < 25 / 10">~</span>
                        </span>
                        <!-- isBiggerMode - smaller -->
                        <!-- <span *ngIf="isBiggerMode"
                            class="position-absolute bottom-0 c-pointer zx-text-small text-center bigger-btn rounded-pill"
                            [class.bigger-btn-not-rtl]="isRTL">
                            <button mat-flat-button (click)="turnOffBiggerMode()" class="zx-text-small zx-text-pink">
                                קטן יותר
                            </button>
                        </span> -->
                    </span>
                    <span class="position-relative">
                        <span id="num-50" (click)="jumpPercent(50)"
                            [class.zx-choosen-size]="resizeNewFactor > 485 / 10 && resizeNewFactor < 515 / 10"
                            class="position-absolute bottom-0 zx-centered zx-size c-pointer zx-text-small"
                            [class.d-none]="maxNewFactor > 250">
                            <span *ngIf="maxNewFactor >= 50">50%</span>
                            <span
                                *ngIf="resizeNewFactor !== 50 && resizeNewFactor > 485 / 10 && resizeNewFactor < 515 / 10">~</span>
                        </span>
                    </span>
                    <span class="position-relative">
                        <span id="num-100" (click)="jumpPercent(100)"
                            [class.zx-choosen-size]="resizeNewFactor > 985 / 10 && resizeNewFactor < 1015 / 10"
                            class="position-absolute bottom-0 zx-centered zx-size c-pointer zx-text-small">
                            <span *ngIf="maxNewFactor >= 100">100%</span>
                            <span
                                *ngIf="resizeNewFactor !== 100 && resizeNewFactor > 985 / 10 && resizeNewFactor < 1015 / 10">~</span>
                        </span>
                    </span>
                    <span id="num-150" class="position-relative">
                        <span (click)="jumpPercent(150)"
                            [class.zx-choosen-size]="resizeNewFactor > 1485 / 10 && resizeNewFactor < 1515 / 10"
                            class="position-absolute bottom-0 zx-centered zx-size c-pointer zx-text-small"
                            [class.d-none]="maxNewFactor > 250">
                            <span *ngIf="maxNewFactor >= 150">150%</span>
                            <span
                                *ngIf="resizeNewFactor !== 150 && resizeNewFactor > 1485 / 10 && resizeNewFactor < 1515 / 10">~</span>
                        </span>
                    </span>
                    <span class="position-relative">
                        <span id="num-200" (click)="jumpPercent(200)"
                            [class.zx-choosen-size]="resizeNewFactor > 1985 / 10 && resizeNewFactor < 2015 / 10"
                            class="position-absolute bottom-0 zx-centered zx-size c-pointer zx-text-small">
                            <span *ngIf="maxNewFactor >= 200">200%</span>
                            <span
                                *ngIf="resizeNewFactor !== 200 && resizeNewFactor > 1985 / 10 && resizeNewFactor < 2015 / 10">~</span>
                        </span>
                    </span>
                    <span class="position-relative">
                        <span id="num-250" (click)="jumpPercent(250)"
                            [class.zx-choosen-size]="resizeNewFactor > 2485 / 10 && resizeNewFactor < 2515 / 10"
                            class="position-absolute bottom-0 zx-centered zx-size c-pointer zx-text-small"
                            [class.d-none]="maxNewFactor > 250">
                            <span *ngIf="maxNewFactor >= 250">250%</span>
                            <span
                                *ngIf="resizeNewFactor !== 250 && resizeNewFactor > 2485 / 10 && resizeNewFactor < 2515 / 10">~</span>
                        </span>
                    </span>
                    <span class="position-relative">
                        <span id="num-300" (click)="jumpPercent(300)"
                            [class.zx-choosen-size]="resizeNewFactor > 2985 / 10 && resizeNewFactor < 3015 / 10"
                            class="position-absolute bottom-0 zx-centered zx-size c-pointer zx-text-small">
                            <span *ngIf="maxNewFactor >= 300">300%</span>
                            <span
                                *ngIf="resizeNewFactor !== 300 && resizeNewFactor > 2985 / 10 && resizeNewFactor < 3015 / 10">~</span>
                        </span>
                    </span>
                    <span class="position-relative">
                        <span id="num-350" (click)="jumpPercent(350)"
                            [class.zx-choosen-size]="resizeNewFactor > 3495 / 10 && resizeNewFactor < 3505 / 10"
                            class="position-absolute bottom-0 zx-centered zx-size c-pointer zx-text-small"
                            [class.d-none]="maxNewFactor > 250">
                            <span *ngIf="maxNewFactor >= 350">350%</span>
                            <span
                                *ngIf="resizeNewFactor !== 350 && resizeNewFactor > 3495 / 10 && resizeNewFactor < 3505 / 10">~</span>
                        </span>
                    </span>
                    <span class="position-relative">
                        <span id="num-400" (click)="jumpPercent(400)"
                            [class.zx-choosen-size]="resizeNewFactor > 3995 / 10"
                            class="position-absolute bottom-0 zx-centered zx-size c-pointer zx-text-small">
                            <span *ngIf="maxNewFactor >= 400">400%</span>
                            <span *ngIf="resizeNewFactor !== 400 && resizeNewFactor > 3995 / 10">~</span>
                        </span>
                        <!-- isBiggerMode - bigger -->
                        <!-- <span
                            *ngIf="maxNewFactorBigger > 405 && (resizeNewFactor <= 400 && resizeNewFactor >= 350) && !isBiggerMode"
                            class="position-absolute bottom-0 c-pointer zx-text-small text-center bigger-btn rounded-pill"
                            [class.bigger-btn-not-rtl]="!isRTL">
                            <button mat-flat-button (click)="turnOnBiggerMode()" class="zx-text-small zx-text-pink">
                                גדול יותר
                            </button>
                        </span> -->
                    </span>
                </div>
            </div>
            <!--  slider -->
            <mat-slider class="w-100 p-0 m-0 zx-z-index-2" min="1" [max]="maxNewFactor" step="0.1">
                <input [(ngModel)]="resizeNewFactor" matSliderThumb>
            </mat-slider>
            <!-- //  slider -->
            <div id="dpi-color-container">
                <div id="dpi-color-high"></div>
                <div id="dpi-color-medium"></div>
                <div id="dpi-color-low"></div>
            </div>
        </div>
        <!-- // slider area -->
        <div class="d-flex flex-grow-1 justify-content-center align-items-end w-100 gap-3 pb-3 pb-lg-0">
            <button color="primary" [disabled]="isLoading" mat-raised-button
                class="text-white rounded-pill zx-btn-single col-6 fw-bold" (click)="resizeImage()">
                {{ "error-content-ok-btn" | translate }}
            </button>
            <button color="warn" mat-button class="rounded-pill zx-btn-single col-6 fw-bold"
                [class.text-white]="isDarkMode" (click)="closeResizeDialog()">
                {{ "su-management.branches_cancel" | translate }}
            </button>
        </div>

        <!-- isLoading -->
        <div class="w-100 h-100 zx-z-index-2 d-flex justify-content-center align-items-center position-absolute"
            *ngIf="isLoading" style="background-color: white;">
            <mat-spinner class="zx-small-icon-size zx-medium-big-icon-size-lg"></mat-spinner>
        </div>
    </div>

</div>